import React from "react";
import { Routes, Route } from "react-router-dom";
import NotFound from "../internal/components/404page";
import TestWidgetPage from "./testWidgetPage";

const DesktopWidgetRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Widget Routes */}
      <Route path="/" element={<TestWidgetPage />} />

      {/* Catch-all for Internal 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default DesktopWidgetRoutes;
